<template>
  <div
    class="modal modal-sign-offs-create fade fixed-end"
    tabindex="-1"
    role="dialog"
  >
    <div
      class="modal-dialog modal-dialog-vertical dw-md-8 dw-lg-6 dw-xl-5"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="drawer-title">
            {{ title }}
          </h2>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <!-- /.drawer-heading -->

        <div class="modal-body">
          <div class="mb-3">
            <label class="control-label">Select Client</label>
            <div class="input-group">
              <span class="input-group-text"
                ><i class="fal fa-fw fa-building"></i
              ></span>
              <div class="flex-grow-1">
                <multiselect
                  :show-labels="false"
                  v-model="client"
                  :options="clients"
                  label="company"
                  track-by="id"
                  placeholder=""
                  v-validate="'required'"
                  data-vv-name="client"
                  @select="clientSelected"
                ></multiselect>
              </div>
            </div>
            <help-block field="client" />
          </div>
          <!-- /.form-group -->

          <div class="mb-3" v-if="client">
            <label class="control-label">Select Contact</label>
            <div class="input-group">
              <span class="input-group-text"
                ><i class="fal fa-fw fa-address-card"></i
              ></span>
              <div class="flex-grow-1">
                <multiselect
                  :show-labels="false"
                  v-model="contact"
                  :options="contacts"
                  label="name"
                  track-by="id"
                  placeholder=""
                  v-validate="'required'"
                  data-vv-name="contact"
                  @select="contactSelected"
                >
                  <template slot="singleLabel" slot-scope="props"
                    ><span class="option__title">{{ props.option.name }}</span
                    ><span class="option__small">{{
                      props.option.email
                    }}</span></template
                  >
                  <template slot="option" slot-scope="props">
                    <div class="option__desc">
                      <span class="option__title">{{ props.option.name }}</span
                      ><span class="option__small">{{
                        props.option.email
                      }}</span>
                    </div>
                  </template>
                </multiselect>
              </div>
            </div>
            <help-block field="contact" />
          </div>
          <!-- /.form-group -->

          <div class="mb-3" v-if="client">
            <label class="control-label">Select Project</label>
            <div class="input-group">
              <div class="flex-grow-1">
                <multiselect
                  :show-labels="false"
                  v-model="project"
                  :options="projects"
                  label="title"
                  track-by="id"
                  placeholder=""
                  v-validate="'required'"
                  data-vv-name="project"
                  @select="projectSelected"
                >
                  <template slot="singleLabel" slot-scope="props"
                    ><span class="option__title">{{
                      props.option.text
                    }}</span></template
                  >
                  <template slot="option" slot-scope="props">
                    <div class="option__desc">
                      <span class="option__title">{{ props.option.text }}</span>
                    </div>
                  </template>
                </multiselect>
              </div>
            </div>
            <help-block field="project" />
          </div>
          <!-- /.form-group -->

          <div class="mb-3" v-if="project">
            <label class="control-label">Select Project Stage</label>
            <div class="input-group">
              <div class="flex-grow-1">
                <multiselect
                  :show-labels="false"
                  v-model="stage"
                  :options="stages"
                  label="title"
                  track-by="id"
                  placeholder=""
                  v-validate="'required'"
                  data-vv-name="stage"
                  @select="stageSelected"
                ></multiselect>
              </div>
            </div>
            <help-block field="stage" />
          </div>
          <!-- /.form-group -->

          <div class="mb-3">
            <label class="control-label">Sign Request Template</label>
            <div class="input-group">
              <span class="input-group-text"
                ><i class="fal fa-fw fa-document"></i
              ></span>
              <div class="flex-grow-1">
                <multiselect
                  :show-labels="false"
                  v-model="template"
                  :options="templates"
                  label="title"
                  track-by="id"
                  placeholder="Select Template"
                  v-validate="'required'"
                  data-vv-name="template"
                  @select="templateSelected"
                ></multiselect>
              </div>
            </div>
            <help-block field="template" />
          </div>
          <!-- /.form-group -->

          <div class="mb-3">
            <label class="control-label">Name</label>
            <input
              name="name"
              v-model="newSignOff.name"
              type="text"
              class="form-control"
              data-vv-validate-on="input|blur"
              data-vv-as="name"
              v-validate="'required'"
            />
            <help-block field="name" />
          </div>

          <div class="mb-3">
            <label class="control-label">Send from</label>
            <div class="input-group">
              <span class="input-group-text"
                ><i class="fal fa-fw fa-user"></i
              ></span>
              <div class="flex-grow-1">
                <multiselect
                  :show-labels="false"
                  v-model="user"
                  :options="users"
                  label="name"
                  track-by="id"
                  placeholder="Select Owner"
                  v-validate="'required'"
                  data-vv-name="user"
                  @select="ownerSelected"
                ></multiselect>
              </div>
            </div>
            <help-block field="user" />
          </div>
          <!-- /.form-group -->

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
            <c-button @click="handleSave" class="btn btn-rounded btn-primary"
              >Save</c-button
            >
          </div>
        </div>
        <!-- /.drawer-body -->
      </div>
      <!-- /.drawer-contents -->
    </div>
  </div>
  <!-- /.drawer -->
</template>

<style scoped>
.invalid-feedback {
  display: inline-block;
}
</style>

<style>
.form-control {
  box-shadow: none !important;
}

.form-control[readonly] {
  background-color: transparent !important;
}
</style>

<script>
import $ from "jquery";
import moment from "moment";
import { http, notify } from "utils";
import { unset, cloneDeep } from "lodash";
import Datepicker from "vuejs-datepicker";
import Multiselect from "vue-multiselect";
import { mapActions, mapState, mapGetters } from "vuex";
import { Selectize, LaddaButton } from "components/form/input";
import { helperMethods } from "vx/modules/clients";
import { CModal } from "@chameleon/chameleon-vue";

export default {
  $_veeValidate: {
    validator: "new", // give me my own validator scope.
  },
  props: ["title", "signOff", "mode"],
  extends: CModal,
  components: {
    Selectize,
    LaddaButton,
    Datepicker,
    Multiselect,
  },

  data() {
    return {
      newSignOff: {},
      client: null,
      contact: null,
      project: null,
      stage: null,
      user: null,
      template: null,
    };
  },

  mounted() {
    this.getClients();
    this.getUsers();
    this.getSignRequestTemplates({ type: "signOff" });

    this.addEventListener('open', () => {
      this.newSignOff = cloneDeep(this.signOff);

      if (
        this.newSignOff &&
        this.newSignOff.contact &&
        this.newSignOff.contact.client_id
      ) {
        this.client = this.getClientById(this.newSignOff.contact.client_id);
        this.getContacts(this.newSignOff.contact.client_id).then(() => {
          this.contact = this.getContactById(this.newSignOff.contact_id);
        });

        this.user = this.getUserById(this.newSignOff.user_id);

        this.getProjects({ client_id: this.newSignOff.contact.client_id }).then(
          () => {
            this.project = this.getProjectById(
              this.newSignOff.project_stage.project_id
            );

            this.getProjectStages({
              project_id: this.newSignOff.project_stage.project_id,
            }).then(() => {
              this.stage = this.getProjectStageById(
                this.newSignOff.project_stage.id
              );
            });
          }
        );
      }
    });
  },

  computed: {
    ...mapState("contacts", ["contacts"]),
    ...mapState("contacts", ["client_id"]),
    ...mapState("clientsList", ["clients"]),
    ...mapState("users", ["users"]),
    ...mapState("projectsList", ["projects"]),
    ...mapState("projectStagesList", ["stages"]),
    ...mapState("signRequestTemplatesList", ["templates"]),
    ...mapGetters("clientsList", { getClientById: "getById" }),
    ...mapGetters("contacts", { getContactById: "getById" }),
    ...mapGetters("users", { getUserById: "getById" }),
    ...mapGetters("projectsList", { getProjectById: "getById" }),
    ...mapGetters("projectStagesList", { getProjectStageById: "getById" }),
  },
  methods: {
    ...helperMethods,
    ...mapActions("signOff", ["addSingle", "updateSingle"]),
    ...mapActions("clientsList", ["getClients"]),
    ...mapActions("contacts", ["getContacts"]),
    ...mapActions("users", ["getUsers"]),
    ...mapActions("projectsList", { getProjects: "getList" }),
    ...mapActions("projectStagesList", { getProjectStages: "getList" }),
    ...mapActions("signRequestTemplatesList", {
      getSignRequestTemplates: "getList",
    }),

    clientSelected(selected) {
      this.newSignOff.client_id = selected.id;
      //Ensure no contact is selected from a previous client selection
      this.contact = null;
      this.project = null;

      this.getContacts(selected.id);
      this.getProjects({ client_id: selected.id });
    },

    contactSelected(selected) {
      this.newSignOff.contact_id = selected.id;
    },

    ownerSelected(selected) {
      this.newSignOff.user_id = selected.id;
    },

    projectSelected(selected) {
      this.newSignOff.project_id = selected.id;

      this.getProjectStages({ project_id: selected.id });
    },

    stageSelected(selected) {
      this.newSignOff.project_stage_id = selected.id;
    },

    templateSelected(selected) {
      this.newSignOff.template_id = selected.id;
    },

    handleSave() {
      if (this.newSignOff.id) {
        return this.handleUpdate();
      } else {
        return this.handleAdd();
      }
    },

    async handleAdd() {
      if (!(await this._validate())) {
        notify.error(
          "Form validation failed, please check your inputs and try again."
        );
        return Promise.reject();
      }

      try {
        return this.addSingle(this.newSignOff)
          .then((response) => {
            //Redirect to new opp
            this.close()
            this.$emit('created')
          })
          .catch((error) => {
            if (error.response.status === 422) {
              notify.error(
                "Form validation failed, please check your inputs and try again."
              );
            } else {
              console.error(error);
              notify.error("Failed to create Sign-Off, please try again.");
            }
          });
      } catch (error) {
        console.error(error);
      }
    },

    async handleUpdate() {
      if (!(await this._validate())) {
        notify.error(
          "Form validation failed, please check your inputs and try again."
        );
        return Promise.reject();
      }

      try {
        return this.updateSingle({
          id: this.newSignOff.id,
          payload: this.newSignOff,
        })
          .then((response) => {
            //Redirect to new opp
            //this.$router.push({ name: 'budgets.show', params: { budget_id: response.data.id } })

            //In case client was changed, refresh the state from the api repsonse
            this.setClient(response.data.client);

            notify.success("Sign-Off successfuly updated.");
            this.close();
            this.$emit("updated");
          })
          .catch((error) => {
            if (error.response.status === 422) {
              notify.error(
                "Form validation failed, please check your inputs and try again."
              );
            } else {
              console.error(error);
              notify.error("Failed to create budget, please try again.");
            }
          });
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
